// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FH-z","hovered":"GH-z","hoverImage":"HH-z","mainImage":"IH-z","imageNoBackground":"JH-z","fullSizeImage":"KH-z"};